// Configuration for Camp Manager access control
// Only users explicitly listed here can access camp management tools

export const CAMP_MANAGER_CONFIG = {
  // List of email addresses that can access camp manager tools
  approvedManagerEmails: [
    'david@fitterandfaster.com',
    'david@arluck.com',
    'cierra@fitterandfaster.com',
    'keith@wordjuice.net',
    'mihamil86@gmail.com',
    'michael@wordjuice.net',
    'dbriggs@fitterandfaster.com',
    'DAVID@ARLUCK.COM',
    'atiba@fitterandfaster.com',
    'jnelson@fitterandfaster.com'
    // Add more manager email addresses here as needed
  ],
  
  // Whether to enable case-sensitive email matching (default: false)
  caseSensitive: false,
  
  // Whether to trim whitespace from emails before comparison (default: true)
  trimWhitespace: true,
  
  // Default redirect path for unauthorized users
  unauthorizedRedirectPath: '/auth/unauthorized',
  
  // Default redirect path for login
  loginRedirectPath: '/auth/login'
};

/**
 * Check if an email is approved to access camp manager tools
 * @param email - The email address to check
 * @returns boolean - True if email is approved, false otherwise
 */
export function isCampManagerApproved(email: string): boolean {
  if (!email) {
    return false;
  }
  
  let normalizedEmail = email;
  let normalizedApprovedEmails = CAMP_MANAGER_CONFIG.approvedManagerEmails;
  
  // Apply trimming if configured
  if (CAMP_MANAGER_CONFIG.trimWhitespace) {
    normalizedEmail = normalizedEmail.trim();
    normalizedApprovedEmails = normalizedApprovedEmails.map(e => e.trim());
  }
  
  // Apply case sensitivity if configured
  if (!CAMP_MANAGER_CONFIG.caseSensitive) {
    normalizedEmail = normalizedEmail.toLowerCase();
    normalizedApprovedEmails = normalizedApprovedEmails.map(e => e.toLowerCase());
  }
  
  return normalizedApprovedEmails.includes(normalizedEmail);
}

/**
 * Add an email to the camp manager approved list
 * @param email - The email address to add
 */
export function addCampManager(email: string): void {
  if (email && !isCampManagerApproved(email)) {
    CAMP_MANAGER_CONFIG.approvedManagerEmails.push(email.toLowerCase().trim());
  }
}

/**
 * Remove an email from the camp manager approved list
 * @param email - The email address to remove
 */
export function removeCampManager(email: string): void {
  if (!email) {
    return;
  }
  
  const normalizedEmail = email.toLowerCase().trim();
  
  const index = CAMP_MANAGER_CONFIG.approvedManagerEmails.findIndex(
    managerEmail => managerEmail.toLowerCase().trim() === normalizedEmail
  );
  
  if (index > -1) {
    CAMP_MANAGER_CONFIG.approvedManagerEmails.splice(index, 1);
  }
}
